import { createContext, useCallback, useContext } from 'react'

import { Children } from 'utils/types'
import { useTermsAcceptanceData } from './hooks/useTermsAcceptanceData'

interface TermsAcceptanceContextType {
  hasAcceptedTerms: boolean
  setAcceptedTerms: (value: boolean) => void
  isAcceptingTerms: boolean
  isLoading: boolean
}

const TermsAcceptanceContext = createContext<TermsAcceptanceContextType | undefined>(undefined)

export const TermsAcceptanceProvider = ({ children }: Children) => {
  const { hasAcceptedTerms, acceptTerms, isAcceptingTerms, isLoading } = useTermsAcceptanceData()

  const setAcceptedTerms = useCallback(
    (value: boolean) => {
      if (!value) {
        return
      }
      acceptTerms()
    },
    [acceptTerms]
  )

  return (
    <TermsAcceptanceContext.Provider value={{ hasAcceptedTerms, setAcceptedTerms, isAcceptingTerms, isLoading }}>
      {children}
    </TermsAcceptanceContext.Provider>
  )
}

export const useTermsAcceptance = () => {
  const context = useContext(TermsAcceptanceContext)
  if (!context) {
    throw new Error('useTermsAcceptance must be used within TermsAcceptanceProvider')
  }
  return context
}
